export class RefreshLink extends HTMLElement {
  constructor() {
    super();

    this.refreshLink = this.querySelector('a');
    if (!this.refreshLink) return;
    this.initClick();
  }

  initClick() {
    this.refreshLink.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation()
      const element = e.target.closest('a[href]');
      const targetUrl = element?.getAttribute('href');
      if (!targetUrl) return;

      if (window.location.href === targetUrl ||
        window.location.pathname === targetUrl || !targetUrl) {
        window.location.reload();
        return;
      }

      window.location.href = targetUrl;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('refresh-link')) {
    customElements.define('refresh-link', RefreshLink);
  }
})